import React, { useState, useEffect } from "react";
import "../styles/about.css";

function About() {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const [accounts, setAccounts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  // 👇 เก็บ id เพื่อรู้ว่าเป็น create หรือ update
  const [editingId, setEditingId] = useState(null);

  const [formData, setFormData] = useState({
    username: "",
    accountNo: "",
    type: "",
    bank: "",
    crypto: "",
  });

  // -------------------------
  // Load user from localStorage
  // -------------------------
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const userData = JSON.parse(storedUser);
      setFormData((prev) => ({
        ...prev,
        username: userData.username,
      }));
    }
  }, []);

  // -------------------------
  // Fetch accounts
  // -------------------------
  const fetchAccounts = () => {
    fetch(`${baseUrl}/admin`)
      .then((res) => res.json())
      .then((data) => {
        console.log("API DATA:", data);
        setAccounts(Array.isArray(data) ? data : data.data || []);
      })
      .catch(console.error);
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  // -------------------------
  // Search (SAFE)
  // -------------------------
  const filteredAccounts = accounts.filter((acc) => {
    if (!searchTerm) return true;

    return (
      (acc.accountNo ?? "").includes(searchTerm) ||
      (acc.username ?? "").includes(searchTerm) ||
      (acc.type ?? "").includes(searchTerm) ||
      (acc.bank ?? "").includes(searchTerm)
    );
  });

  // -------------------------
  // Handlers
  // -------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRowClick = (account) => {
    setEditingId(account.id); // 👈 สำคัญ
    setFormData({
      username: account.username,
      accountNo: account.accountNo,
      type: account.type,
      bank: account.bank,
      crypto: account.crypto,
    });
  };

  const resetForm = () => {
    setEditingId(null);
    setFormData((prev) => ({
      ...prev,
      accountNo: "",
      type: "",
      bank: "",
      crypto: "",
    }));
  };

  // -------------------------
  // SUBMIT (CREATE / UPDATE)
  // -------------------------
  const handleSubmit = (e) => {
    e.preventDefault();

    const method = editingId ? "PUT" : "POST";
    const url = editingId
      ? `${baseUrl}/admin/${editingId}`
      : `${baseUrl}/admin`;

    fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then(() => {
        fetchAccounts(); // reload table
        resetForm();
      })
      .catch(console.error);
  };

  return (
    <div className="about-page">
      <div className="about-content">
        <h2>{editingId ? "Update Account" : "Add Account"}</h2>

        {/* FORM */}
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="type"
            placeholder="Type: Bank or Crypto"
            value={formData.type}
            onChange={handleChange}
          />
          <input
            type="text"
            name="accountNo"
            placeholder="accountNo"
            value={formData.accountNo}
            onChange={handleChange}
          />

          <button type="submit">{editingId ? "Update" : "Create"}</button>

          {editingId && (
            <button type="button" onClick={resetForm}>
              Cancel
            </button>
          )}
        </form>

        {/* SEARCH */}
        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        {/* TABLE */}
        <table>
          <thead>
            <tr>
              <th>Type</th>
              <th>Account No</th>
            </tr>
          </thead>
          <tbody>
            {filteredAccounts.map((account) => (
              <tr key={account.id} onClick={() => handleRowClick(account)}>
                <td>{account.type || "-"}</td>
                <td>{account.accountNo || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default About;
